export default __webpack_public_path__ + "static/media/share-icon.88fb82ca.svg";